import { createAsyncTypes } from 'store/utils';

// State Key
export const KEY = 'events';

// Action Types
export const types = {
  LOG_EVENT_ASYNC: createAsyncTypes(`${KEY}/LOG_EVENT_ASYNC`),
  GET_EVENTS_ASYNC: createAsyncTypes(`${KEY}/GET_EVENTS_ASYNC`),
  GET_LATEST_EVENTS_ASYNC: createAsyncTypes(`${KEY}/GET_LATEST_EVENTS_ASYNC`)
};

export const eventNames: { [x: string]: string } = {
  KIOSK_ACTIVE: 'Kiosk Active',
  KIOSK_INACTIVE: 'Kiosk Inactive',
  KIOSK_REBOOTED: 'Kiosk Rebooted',
  KIOSK_TICKET_STOCK_RELOADED: 'Ticket Stock Reloaded',
  SCANNER_RESOLVED: 'Scanner Resolved',
  PRINTER_RESOLVED: 'Printer Resolved',
  PAYMENT_RESOLVED: 'Payment Device Resolved',
  EVENT_DATA_REFRESHED: 'Event Data Refreshed',
  HARDWARE_CONNECTTION_CONFIRMED: 'Hardware Connection Confirmed'
};

export type EventCategories =
  | 'reboot'
  | 'active_status'
  | 'ticket_stock_reload'
  | 'payment_status'
  | 'printer_status'
  | 'scanner_status'
  | 'event_data_refresh'
  | 'hardware_status';

export interface KioskEvent {
  id: string;
  kioskId: string;
  event: string;
  actorId?: string;
  actorInfo: {
    name?: string;
  };
  createdAt: string;
  category: EventCategories;
}

export interface HardwareEvent {
  id: string;
  kioskHardwareId: string;
  event: string;
  actorId?: string;
  actorInfo: {
    name?: string;
  };
  createdAt: string;
  category: EventCategories;
}

export interface KioskHardwareEvents {
  kioskHardwareId: string;
  logEntries: HardwareEvent[];
}

export interface EventState {
  latest: {
    kioskEvents: KioskEvent[];
    kioskHardwareEvents: HardwareEvent[];
  };
  history: {
    kioskEvents: KioskEvent[];
    kioskHardwareEvents: KioskHardwareEvents[];
  };
  loading: boolean;
  error?: string;
}

// eslint-disable-next-line no-unused-vars
export type NormalizedKioskEvents = { [x in EventCategories]?: KioskEvent };
// eslint-disable-next-line no-unused-vars
export type NormalizedKioskHardwareEvents = { [x in EventCategories]: HardwareEvent };

export interface EventPayload {
  event: string;
  category: EventCategories;
  includeActor?: boolean;
  actorId?: string;
  kioskHardwareId?: string;
  status?: string;
}

export interface LogEventRequest {
  type: typeof types.LOG_EVENT_ASYNC.REQUEST;
  payload: EventPayload;
}

export interface LogEventError {
  type: typeof types.LOG_EVENT_ASYNC.ERROR;
  payload: string;
}

export interface LogEventPending {
  type: typeof types.LOG_EVENT_ASYNC.PENDING;
  payload: boolean;
}

export interface LogEventSuccess {
  type: typeof types.LOG_EVENT_ASYNC.SUCCESS;
}

export interface GetEventsResponse {
  kioskEvents: KioskEvent[];
  kioskHardwareEvents: KioskHardwareEvents[];
}

export interface GetEventsRequest {
  type: typeof types.GET_EVENTS_ASYNC.REQUEST;
}

export interface GetEventsError {
  type: typeof types.GET_EVENTS_ASYNC.ERROR;
  payload: string;
}

export interface GetEventsPending {
  type: typeof types.GET_EVENTS_ASYNC.PENDING;
  payload: boolean;
}

export interface GetEventsSuccess {
  type: typeof types.GET_EVENTS_ASYNC.SUCCESS;
  payload: GetEventsResponse;
}

export interface GetLatestEventsResponse {
  kioskEvents: KioskEvent[];
  kioskHardwareEvents: HardwareEvent[];
}

export interface GetLatestEventsRequest {
  type: typeof types.GET_LATEST_EVENTS_ASYNC.REQUEST;
}

export interface GetLatestEventsError {
  type: typeof types.GET_LATEST_EVENTS_ASYNC.ERROR;
  payload: string;
}

export interface GetLatestEventsPending {
  type: typeof types.GET_LATEST_EVENTS_ASYNC.PENDING;
  payload: boolean;
}

export interface GetLatestEventsSuccess {
  type: typeof types.GET_LATEST_EVENTS_ASYNC.SUCCESS;
  payload: GetLatestEventsResponse;
}

export type EventActionTypes =
  | LogEventRequest
  | LogEventError
  | LogEventPending
  | LogEventSuccess
  | GetEventsRequest
  | GetEventsError
  | GetEventsPending
  | GetEventsSuccess
  | GetLatestEventsRequest
  | GetLatestEventsError
  | GetLatestEventsPending
  | GetLatestEventsSuccess;
